import {Component, Input, TemplateRef} from '@angular/core';

@Component({
  selector: 'app-show-more',
  templateUrl: './show-more.component.html',
  styleUrls: ['./show-more.component.scss']
})
export class ShowMoreComponent {
  @Input() public inputItems: any[] = [];
  @Input() public inputTemplate: TemplateRef<any>;
  @Input() public breakLine: boolean;
  @Input() public maxItems: number = 1;
  @Input() public expandStrings: {more: string; less: string;};
  @Input() public showCount: boolean = false;
  @Input() public useList: boolean;

  public expanded: boolean;

  constructor() {}

}
